module.exports = __webpack_public_path__ + "img/ppr.0f9730e2.svg";